__turbopack_context__.v({
  "badge": "feature-carousel-module__6wZ4FG__badge",
  "bars": "feature-carousel-module__6wZ4FG__bars",
  "chartAxis": "feature-carousel-module__6wZ4FG__chartAxis",
  "chartCard": "feature-carousel-module__6wZ4FG__chartCard",
  "clusterCard": "feature-carousel-module__6wZ4FG__clusterCard",
  "clusterGrid": "feature-carousel-module__6wZ4FG__clusterGrid",
  "flowCard": "feature-carousel-module__6wZ4FG__flowCard",
  "frame": "feature-carousel-module__6wZ4FG__frame",
  "lineStack": "feature-carousel-module__6wZ4FG__lineStack",
  "mainFoot": "feature-carousel-module__6wZ4FG__mainFoot",
  "mainPanel": "feature-carousel-module__6wZ4FG__mainPanel",
  "metaCard": "feature-carousel-module__6wZ4FG__metaCard",
  "metaLabel": "feature-carousel-module__6wZ4FG__metaLabel",
  "metric": "feature-carousel-module__6wZ4FG__metric",
  "mid": "feature-carousel-module__6wZ4FG__mid",
  "miniLabel": "feature-carousel-module__6wZ4FG__miniLabel",
  "reasonCard": "feature-carousel-module__6wZ4FG__reasonCard",
  "screenshot": "feature-carousel-module__6wZ4FG__screenshot",
  "screenshotActive": "feature-carousel-module__6wZ4FG__screenshotActive",
  "screenshotHidden": "feature-carousel-module__6wZ4FG__screenshotHidden",
  "screenshotSurface": "feature-carousel-module__6wZ4FG__screenshotSurface",
  "short": "feature-carousel-module__6wZ4FG__short",
  "sidePanel": "feature-carousel-module__6wZ4FG__sidePanel",
  "stage": "feature-carousel-module__6wZ4FG__stage",
  "surface": "feature-carousel-module__6wZ4FG__surface",
  "surfaceTop": "feature-carousel-module__6wZ4FG__surfaceTop",
  "tabActive": "feature-carousel-module__6wZ4FG__tabActive",
  "tabs": "feature-carousel-module__6wZ4FG__tabs",
  "windowBar": "feature-carousel-module__6wZ4FG__windowBar",
});
